document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector(".menu-toggle");
  const menu = document.querySelector(".menu");
  const nav = document.querySelector(".navigation");
  const aanbodToggle = document.querySelector(".aanbod-toggle");
  const backButton = document.querySelector(".back-to-pages");
  const menuPages = document.querySelector(".menu-pages");
  const menuCategories = document.querySelector(".menu-categories");

  // Cart modal elements
  const cartModal = document.querySelector("#cart-modal");

  if (!menuToggle || !menu) return;

  menuToggle.setAttribute("aria-expanded", "false");
  menuToggle.setAttribute("aria-label", "Open navigatie");
  menu.setAttribute("aria-hidden", "true");
  menuPages?.setAttribute("aria-hidden", "false");
  menuCategories?.setAttribute("aria-hidden", "true");
  aanbodToggle?.setAttribute("aria-expanded", "false");

  let isOpen = false;

  const resetPanels = () => {
    menuPages?.classList.remove("ghost");
    menuCategories?.classList.add("ghost");
    menuPages?.setAttribute("aria-hidden", "false");
    menuCategories?.setAttribute("aria-hidden", "true");
    aanbodToggle?.setAttribute("aria-expanded", "false");
  };

  const updateMenuState = () => {
    isOpen = menu.classList.contains("open");
    menuToggle.textContent = isOpen ? "Close" : "Menu";
    menuToggle.classList.toggle("text-white", isOpen);
    menuToggle.setAttribute("aria-expanded", String(isOpen));
    menuToggle.setAttribute(
      "aria-label",
      isOpen ? "Sluit navigatie" : "Open navigatie"
    );
    menu.setAttribute("aria-hidden", String(!isOpen));
    animateWowElements(isOpen);

    // Close cart modal when menu opens
    if (isOpen && cartModal && !cartModal.classList.contains("hidden")) {
      cartModal.classList.add("hidden");
    }

    if (!isOpen) {
      resetPanels();
    }
  };

  const animateWowElements = (animate) => {
    document.querySelectorAll(".wow").forEach((el, index) => {
      if (animate) {
        // Staggered animation on open
        setTimeout(() => el.classList.add("animate"), index * 300);
      } else {
        // Instant removal of animation class when closing
        el.classList.remove("animate");
      }
    });
  };

  const showCategories = () => {
    menuPages?.classList.add("ghost");
    menuCategories?.classList.remove("ghost");
    menuPages?.setAttribute("aria-hidden", "true");
    menuCategories?.setAttribute("aria-hidden", "false");
    aanbodToggle?.setAttribute("aria-expanded", "true");
    animateWowElements(true); // Staggered animation when showing categories
  };

  const showPages = () => {
    menuCategories?.classList.add("ghost");
    menuPages?.classList.remove("ghost");
    menuCategories?.setAttribute("aria-hidden", "true");
    menuPages?.setAttribute("aria-hidden", "false");
    aanbodToggle?.setAttribute("aria-expanded", "false");
    animateWowElements(true); // Staggered animation when showing pages
  };

  menuToggle.addEventListener("click", () => {
    menu.classList.toggle("open");
    nav.classList.toggle("open");
    updateMenuState();

    // close shoppingcart
    if (
      menu.classList.contains("open") &&
      typeof shoppingCart !== "undefined"
    ) {
      shoppingCart.closeCart();
    }
  });

  aanbodToggle?.addEventListener("click", showCategories);
  backButton?.addEventListener("click", showPages);

  const navigation = document.querySelector(".navigation");

  function updateNavigationClasses() {
    if (window.innerWidth > 768) {
      navigation.classList.remove("fill", "text-white", "nav-home");
    } else {
      // Optional: if you want to RE-ADD it for mobile only when on home page
      if (navigation.classList.contains("nav-home")) {
        navigation.classList.add("fill", "text-white", "font-medium");
      }
    }
  }

  // Run once at page load
  updateNavigationClasses();

  // Run on window resize
  window.addEventListener("resize", updateNavigationClasses);
});
